export const MAX_SUGGESTIONS_DISPLAY = 9
export const MAX_ITEMS_IN_ROW = 6
